import { toast } from 'react-toastify';

const taskReducer = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_TASK': {
      toast.success('Action ajoutée avec succès !');
      return state;
    }
    case 'ADD_TASK_ERR': {
      toast.error("Une erreur s'est produite");
      return state;
    }
    case 'REMOVE_TASK': {
      toast.success('Action supprimée avec succès !');
      return state;
    }
    case 'REMOVE_TASK_ERR': {
      toast.error("L'action supprimée a déclenché une erreur...");
      return state;
    }
    case 'EDIT_TASK': {
      toast.success('Action éditée');
      return state;
    }
    case 'EDIT_TASK_ERR': {
      toast.error("L'action éditée a déclenché une erreur...");
      return state;
    }
    case 'TOGGLE_CHECKED': {
      toast.info("Le status de l'action a changé...");
      return state;
    }
    case 'TOGGLE_CHECKED_ERR': {
      toast.error("Le status de l'action a provoqué une erreur...");
      return state;
    }
    case 'ADD_COLOR_PICKER': {
      toast.info('La couleur a bien été modifié...');
      return state;
    }
    case 'ADD_COLOR_PICKER_ERR': {
      toast.error('La couleur changée a provoqué une erreur...');
      return state;
    }
    default:
      return state;
  }
};

export default taskReducer;
